import {React, useState, useEffect, } from 'react';
import { Bar } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';
import {Chart} from 'chart.js'

import ChartDataLabels from 'chartjs-plugin-datalabels';
import { useAppContext } from "contexts/AppContext"

const PORTFOLIO_BAR_CSS_VARS = [
  "--portfolio-summary-bar-1",
  "--portfolio-summary-bar-2",
  "--portfolio-summary-bar-3",
  "--portfolio-summary-bar-4",
];

const PORTFOLIO_BAR_FALLBACK = ["#5c6370", "#657592", "#5f7268", "#847963"];

function readPortfolioBarColor(index) {
  const i = index % PORTFOLIO_BAR_CSS_VARS.length;
  if (typeof document === "undefined") {
    return PORTFOLIO_BAR_FALLBACK[i];
  }
  const v = getComputedStyle(document.documentElement)
    .getPropertyValue(PORTFOLIO_BAR_CSS_VARS[i])
    .trim();
  return v || PORTFOLIO_BAR_FALLBACK[i];
}


const PortfolioChart = ({width, height, ...props}) => {
  const chartData = props.data
  const { t } = useTranslation();
  
  const { getPortfolioName, getUserTypeName, getTransactionType } = useAppContext()

  const [duration, setDuration] = useState(1000);

  useEffect(() => {
    setDuration(0);
  }, []);


const portfolioIds = Object.keys(chartData);
const summaryTypes = Object.keys(chartData[portfolioIds[0]]);

const labels = portfolioIds.map((portfolioId) => {
  if (portfolioId === 'summary') {
    return t('Summary', 'Yhteenveto');
  }
  return getPortfolioName(Number(portfolioId)) ;
});

const datasets = summaryTypes.map((summaryType, index) => {
  const data = portfolioIds.map((portfolioId) => chartData[portfolioId][summaryType]);

  return {
        label: t(summaryType,"-"),
        data: data,
        backgroundColor: readPortfolioBarColor(index),
        borderRadius: 10, // Set the bar border radius
    };
  });

  const options = {
      // animation: {
      //   duration: duration, // Set the animation duration to 0
      // },
      layout: {
        padding: {
          bottom: 0,
          left: 0,
          right: 0,
          top: 20
        }
      },
      scales: {
        y: {
          beginAtZero: true,
          grid: {
            drawOnChartArea: false, // Hide grid lines except the 0 line
          },
          ticks: {
            suggestedMin: 0, // Start the chart from 0
          },

        },
        x: {
          ticks: {
            display: false, // Hide the x-axis labels
          },
        },
      },

      responsive: true,
      maintainAspectRatio: false,
      plugins: {

        title: {
          display: false,
          text: t('Portfolio Summary', 'Salkun yhteenveto'),
        },
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            boxWidth: 20,
            fontColor: '#495057',
          },
        },
        datalabels: {
          display: true, // Display the data labels on the bars
          color: 'rgba(73, 80, 87, 0.85)',
          anchor: 'end', // Position the labels at the end of the bars
          align: 'end', // Align the labels to the end of the bars
          formatter: (value) => value.toFixed(2), // Format the value to display with two decimal places
          labels:{
            value: {
              
              font: {
                weight: 'bold' // Set the font weight to bold
              }, 
            },
          }
        },
      }
      ,
      animation: {
          duration: duration,

      }
      
    };

  const data = {
    labels: labels,
    datasets: datasets,
  };
    
  
    const wrapperStyle =
      height != null
        ? { height: typeof height === "number" || /^\d+$/.test(String(height)) ? `${height}px` : height }
        : undefined;

    return (
      <div className="portfolios-summary-bar-chart" style={wrapperStyle}>
        <Bar data={data} options={options} plugins={[ChartDataLabels]} />
      </div>
    );
  };
  
  export default PortfolioChart;